import { render, staticRenderFns } from "./ReturnDivisionHead.vue?vue&type=template&id=6d927256&scoped=true&"
import script from "./ReturnDivisionHead.vue?vue&type=script&lang=js&"
export * from "./ReturnDivisionHead.vue?vue&type=script&lang=js&"
import style0 from "./ReturnDivisionHead.vue?vue&type=style&index=0&id=6d927256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d927256",
  null
  
)

export default component.exports